<template>
  <ac-unit v-if="valueName == 'ac_unit'" />
  <airport-shuttle v-else-if="valueName == 'airport_shuttle'" />
  <all-inclusive v-else-if="valueName == 'all_inclusive'" />
  <apartment v-else-if="valueName == 'apartment'" />
  <baby-changing-station v-else-if="valueName == 'baby_changing_station'" />
  <backpack v-else-if="valueName == 'backpack'" />
  <bathtub v-else-if="valueName == 'bathtub'" />
  <beach-access v-else-if="valueName == 'beach_access'" />
  <bento v-else-if="valueName == 'bento'" />
  <business-center v-else-if="valueName == 'business_center'" />
  <carpenter v-else-if="valueName == 'carpenter'" />
  <casino v-else-if="valueName == 'casino'" />
  <charging-station v-else-if="valueName == 'charging_station'" />
  <checkroom v-else-if="valueName == 'checkroom'" />
  <child-care v-else-if="valueName == 'child_care'" />
  <child-friendly v-else-if="valueName == 'child_friendly'" />
  <corporate-fare v-else-if="valueName == 'corporate_fare'" />
  <countertops v-else-if="valueName == 'countertops'" />
  <do-not-step v-else-if="valueName == 'do_not_step'" />
  <do-not-touch v-else-if="valueName == 'do_not_touch'" />
  <dry v-else-if="valueName == 'dry'" />
  <elevator v-else-if="valueName == 'elevator'" />
  <escalator v-else-if="valueName == 'escalator'" />
  <escalator-warning v-else-if="valueName == 'escalator_warning'" />
  <family-restroom v-else-if="valueName == 'family_restroom'" />
  <fence v-else-if="valueName == 'fence'" />
  <fire-extinguisher v-else-if="valueName == 'fire_extinguisher'" />
  <fitness-center v-else-if="valueName == 'fitness_center'" />
  <food-bank v-else-if="valueName == 'food_bank'" />
  <foundation v-else-if="valueName == 'foundation'" />
  <free-breakfast v-else-if="valueName == 'free_breakfast'" />
  <golf-course v-else-if="valueName == 'golf_course'" />
  <grass v-else-if="valueName == 'grass'" />
  <hot-tub v-else-if="valueName == 'hot_tub'" />
  <house v-else-if="valueName == 'house'" />
  <house-siding v-else-if="valueName == 'house_siding'" />
  <kitchen v-else-if="valueName == 'kitchen'" />
  <meeting-room v-else-if="valueName == 'meeting_room'" />
  <microwave v-else-if="valueName == 'microwave'" />
  <night-shelter v-else-if="valueName == 'night_shelter'" />
  <no-backpack v-else-if="valueName == 'no_backpack'" />
  <no-cell v-else-if="valueName == 'no_cell'" />
  <no-drinks v-else-if="valueName == 'no_drinks'" />
  <no-flash v-else-if="valueName == 'no_flash'" />
  <no-food v-else-if="valueName == 'no_food'" />
  <no-meeting-room v-else-if="valueName == 'no_meeting_room'" />
  <no-photography v-else-if="valueName == 'no_photography'" />
  <no-stroller v-else-if="valueName == 'no_stroller'" />
  <pool v-else-if="valueName == 'pool'" />
  <rice-bowl v-else-if="valueName == 'rice_bowl'" />
  <roofing v-else-if="valueName == 'roofing'" />
  <room-preferences v-else-if="valueName == 'room_preferences'" />
  <room-service v-else-if="valueName == 'room_service'" />
  <rv-hookup v-else-if="valueName == 'rv_hookup'" />
  <smoke-free v-else-if="valueName == 'smoke_free'" />
  <smoking-rooms v-else-if="valueName == 'smoking_rooms'" />
  <soap v-else-if="valueName == 'soap'" />
  <spa v-else-if="valueName == 'spa'" />
  <sports-bar v-else-if="valueName == 'sports_bar'" />
  <stairs v-else-if="valueName == 'stairs'" />
  <storefront v-else-if="valueName == 'storefront'" />
  <stroller v-else-if="valueName == 'stroller'" />
  <tapas v-else-if="valueName == 'tapas'" />
  <tty v-else-if="valueName == 'tty'" />
  <umbrella v-else-if="valueName == 'umbrella'" />
  <wash v-else-if="valueName == 'wash'" />
  <water-damage v-else-if="valueName == 'water_damage'" />
  <wheelchair-pickup v-else-if="valueName == 'wheelchair_pickup'" />
</template>

<script>
import AcUnit from "@/components/Icons/Places/AcUnit";
import AirportShuttle from "@/components/Icons/Places/AirportShuttle";
import AllInclusive from "@/components/Icons/Places/AllInclusive";
import Apartment from "@/components/Icons/Places/Apartment";
import BabyChangingStation from "@/components/Icons/Places/BabyChangingStation";
import Backpack from "@/components/Icons/Places/Backpack";
import Bathtub from "@/components/Icons/Places/Bathtub";
import BeachAccess from "@/components/Icons/Places/BeachAccess";
import Bento from "@/components/Icons/Places/Bento";
import BusinessCenter from "@/components/Icons/Places/BusinessCenter";
import Carpenter from "@/components/Icons/Places/Carpenter";
import Casino from "@/components/Icons/Places/Casino";
import ChargingStation from "@/components/Icons/Places/ChargingStation";
import Checkroom from "@/components/Icons/Places/Checkroom";
import ChildCare from "@/components/Icons/Places/ChildCare";
import ChildFriendly from "@/components/Icons/Places/ChildFriendly";
import CorporateFare from "@/components/Icons/Places/CorporateFare";
import Countertops from "@/components/Icons/Places/Countertops";
import DoNotStep from "@/components/Icons/Places/DoNotStep";
import DoNotTouch from "@/components/Icons/Places/DoNotTouch";
import Dry from "@/components/Icons/Places/Dry";
import Elevator from "@/components/Icons/Places/Elevator";
import Escalator from "@/components/Icons/Places/Escalator";
import EscalatorWarning from "@/components/Icons/Places/EscalatorWarning";
import FamilyRestroom from "@/components/Icons/Places/FamilyRestroom";
import Fence from "@/components/Icons/Places/Fence";
import FireExtinguisher from "@/components/Icons/Places/FireExtinguisher";
import FitnessCenter from "@/components/Icons/Places/FitnessCenter";
import FoodBank from "@/components/Icons/Places/FoodBank";
import Foundation from "@/components/Icons/Places/Foundation";
import FreeBreakfast from "@/components/Icons/Places/FreeBreakfast";
import GolfCourse from "@/components/Icons/Places/GolfCourse";
import Grass from "@/components/Icons/Places/Grass";
import HotTub from "@/components/Icons/Places/HotTub";
import House from "@/components/Icons/Places/House";
import HouseSiding from "@/components/Icons/Places/HouseSiding";
import Kitchen from "@/components/Icons/Places/Kitchen";
import MeetingRoom from "@/components/Icons/Places/MeetingRoom";
import Microwave from "@/components/Icons/Places/Microwave";
import NightShelter from "@/components/Icons/Places/NightShelter";
import NoBackpack from "@/components/Icons/Places/NoBackpack";
import NoCell from "@/components/Icons/Places/NoCell";
import NoDrinks from "@/components/Icons/Places/NoDrinks";
import NoFlash from "@/components/Icons/Places/NoFlash";
import NoFood from "@/components/Icons/Places/NoFood";
import NoMeetingRoom from "@/components/Icons/Places/NoMeetingRoom";
import NoPhotography from "@/components/Icons/Places/NoPhotography";
import NoStroller from "@/components/Icons/Places/NoStroller";
import Pool from "@/components/Icons/Places/Pool";
import RiceBowl from "@/components/Icons/Places/RiceBowl";
import Roofing from "@/components/Icons/Places/Roofing";
import RoomPreferences from "@/components/Icons/Places/RoomPreferences";
import RoomService from "@/components/Icons/Places/RoomService";
import RvHookup from "@/components/Icons/Places/RvHookup";
import SmokeFree from "@/components/Icons/Places/SmokeFree";
import SmokingRooms from "@/components/Icons/Places/SmokingRooms";
import Soap from "@/components/Icons/Places/Soap";
import Spa from "@/components/Icons/Places/Spa";
import SportsBar from "@/components/Icons/Places/SportsBar";
import Stairs from "@/components/Icons/Places/Stairs";
import Storefront from "@/components/Icons/Places/Storefront";
import Stroller from "@/components/Icons/Places/Stroller";
import Tapas from "@/components/Icons/Places/Tapas";
import Tty from "@/components/Icons/Places/Tty";
import Umbrella from "@/components/Icons/Places/Umbrella";
import Wash from "@/components/Icons/Places/Wash";
import WaterDamage from "@/components/Icons/Places/WaterDamage";
import WheelchairPickup from "@/components/Icons/Places/WheelchairPickup";

export default {
  components: {
    AcUnit,
    AirportShuttle,
    AllInclusive,
    Apartment,
    BabyChangingStation,
    Backpack,
    Bathtub,
    BeachAccess,
    Bento,
    BusinessCenter,
    Carpenter,
    Casino,
    ChargingStation,
    Checkroom,
    ChildCare,
    ChildFriendly,
    CorporateFare,
    Countertops,
    DoNotStep,
    DoNotTouch,
    Dry,
    Elevator,
    Escalator,
    EscalatorWarning,
    FamilyRestroom,
    Fence,
    FireExtinguisher,
    FitnessCenter,
    FoodBank,
    Foundation,
    FreeBreakfast,
    GolfCourse,
    Grass,
    HotTub,
    House,
    HouseSiding,
    Kitchen,
    MeetingRoom,
    Microwave,
    NightShelter,
    NoBackpack,
    NoCell,
    NoDrinks,
    NoFlash,
    NoFood,
    NoMeetingRoom,
    NoPhotography,
    NoStroller,
    Pool,
    RiceBowl,
    Roofing,
    RoomPreferences,
    RoomService,
    RvHookup,
    SmokeFree,
    SmokingRooms,
    Soap,
    Spa,
    SportsBar,
    Stairs,
    Storefront,
    Stroller,
    Tapas,
    Tty,
    Umbrella,
    Wash,
    WaterDamage,
    WheelchairPickup,
  },
  props: {
    valueName: {
      type: [String],
    },
  },
};
</script>
